var _rect, _g, _text, _rect2, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg108(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 450",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, "1233\uD68C \uB85C\uB610 \uBC88\uD638\uD569\uACC4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "t"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 450,
    rx: 28,
    fill: "#f4f0ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "sans-serif",
    fontSize: 26,
    fontWeight: 900,
    textAnchor: "middle",
    fill: "#172033"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 150,
    r: 42,
    fill: "#ffd666"
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 159
  }, "3"), /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 150,
    r: 42,
    fill: "#b9e6dc"
  }), /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 159
  }, "8"), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 150,
    r: 42,
    fill: "#d9ccff"
  }), /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 159
  }, "17"), /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 150,
    r: 42,
    fill: "#ffd6db"
  }), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 159
  }, "24"), /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 150,
    r: 42,
    fill: "#ffd666"
  }), /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 159
  }, "31"), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 150,
    r: 42,
    fill: "#b9e6dc"
  }), /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 159
  }, "42"))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 680,
    y: 164,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 46,
    fontWeight: 900,
    fill: "#0f766e"
  }, "\u03A3")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 250,
    width: 440,
    height: 110,
    rx: 28,
    fill: "#fff",
    stroke: "#8065c7",
    strokeWidth: 8
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 322,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 55,
    fontWeight: 900,
    fill: "#172033"
  }, "\uD569\uACC4 125")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 412,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 27,
    fontWeight: 800,
    fill: "#634ca8"
  }, "\uD558\uB098\uC758 \uC694\uC57D\uAC12\uC73C\uB85C\uB9CC \uBE44\uAD50\uD558\uC138\uC694")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg108);
export default __webpack_public_path__ + "static/media/108-번호합계.e1e91df788021a84b3360ffdc5170758.svg";
export { ForwardRef as ReactComponent };